import { $api, unwrap } from '~/lib/api-client';

import { queryOptions, skipToken } from '@tanstack/react-query';

interface ILiftStatusRequest {
  organisationId?: number;
  from?: string;
  to?: string;
  startHour?: number;
  startMinute?: number;
  endHour?: number;
  endMinute?: number;
}

export const dashboardStatsQueryOptions = ({
  viewIsCurrent,
  ...request
}: ILiftStatusRequest & { viewIsCurrent: boolean }) =>
  queryOptions({
    refetchInterval: 60000, // refetch every minute
    queryKey: ['liftstatus', 'stats', viewIsCurrent, request],
    queryFn: request.organisationId
      ? async ({ signal }) => {
          if (viewIsCurrent) {
            return unwrap(
              $api['/liftstatus/current-state'].GET({
                params: {
                  query: { organisationId: request.organisationId ?? 0 },
                },
                signal,
              })
            );
          }

          return unwrap(
            $api['/liftstatus/stats'].GET({
              params: {
                query: {
                  organisationId: request.organisationId ?? 0,
                  from: request.from,
                  to: request.to,
                  startHour: request.startHour
                    ? String(request.startHour)
                    : undefined,
                  endHour: request.endHour
                    ? String(request.endHour)
                    : undefined,
                },
              },
              signal,
            })
          );
        }
      : skipToken,
  });
